// extracted by mini-css-extract-plugin
export default {"selection":"TargetHighlight-module__selection--jnGbv","comment":"TargetHighlight-module__comment--srZ6E","annotation":"TargetHighlight-module__annotation--cVIQ2"};